import React, { useState } from 'react';

interface SeasonalWarningProps {
  warnings: string[];
  onDismiss?: () => void;
}

export const SeasonalWarning: React.FC<SeasonalWarningProps> = ({
  warnings,
  onDismiss
}) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (warnings.length === 0 || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setIsDismissed(true);
    onDismiss?.();
  };

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg className="w-5 h-5 text-amber-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-amber-800">
            Seasonal Service Notice
          </h3>
          <div className="mt-2 space-y-1">
            {warnings.map((warning, index) => (
              <p key={index} className="text-sm text-amber-700">
                {warning}
              </p>
            ))}
          </div>
          <div className="mt-3 text-xs text-amber-600">
            Services may be limited outside festival periods. Check official schedules for updates.
          </div>
        </div>
        <div className="ml-3 flex-shrink-0">
          <button
            type="button"
            onClick={handleDismiss}
            className="inline-flex rounded-md bg-amber-50 p-1.5 text-amber-500 hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-amber-600 focus:ring-offset-2 focus:ring-offset-amber-50"
          >
            <span className="sr-only">Dismiss</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};